"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSavings = exports.getMonthlySavings = exports.getFormattedSaving = void 0;
var _intlFormatter = require("@godaddy/intl-formatter");
const getFees = (sales, ratio, rate) => {
  return sales * ratio * rate;
};
const getMonthly = ({
  sales,
  ratio,
  transactions,
  inPersonRate,
  perInPersonTxnFee,
  onlineRate,
  perOnlineTxnFee
}) => {
  const monthlySales = sales / 12;
  const inPersonFees = getFees(monthlySales, 1 - ratio, inPersonRate);
  const perInPersonTxnFees = getFees(transactions, 1 - ratio, perInPersonTxnFee);
  const onlineFees = getFees(monthlySales, ratio, onlineRate);
  const perOnlineTxnFees = getFees(transactions, ratio, perOnlineTxnFee);
  return inPersonFees + perInPersonTxnFees + onlineFees + perOnlineTxnFees;
};
const getSavings = ({
  sales,
  transactions,
  ratio,
  years
}) => {
  const formattedRatio = ratio / 100;
  const competitorAvgInPersonRate = 0.0267;
  const competitorAvgPerInPersonTxnFee = 0.05;
  const competitorAvgOnlineRate = 0.029;
  const competitorAvgPerOnlineTxnFee = 0.03;
  const godaddyInPersonRate = 0.023;
  const godaddyPerInPersonTxnFee = 0;
  const godaddyOnlineRate = 0.023;
  const godaddyPerOnlineTxnFee = 0.03;
  const competitorAvgAnnualFees = getMonthly({
    sales,
    ratio: formattedRatio,
    transactions,
    inPersonRate: competitorAvgInPersonRate,
    perInPersonTxnFee: competitorAvgPerInPersonTxnFee,
    onlineRate: competitorAvgOnlineRate,
    perOnlineTxnFee: competitorAvgPerOnlineTxnFee
  }) * 12;
  const godaddyAnnualFees = getMonthly({
    sales,
    ratio: formattedRatio,
    transactions,
    inPersonRate: godaddyInPersonRate,
    perInPersonTxnFee: godaddyPerInPersonTxnFee,
    onlineRate: godaddyOnlineRate,
    perOnlineTxnFee: godaddyPerOnlineTxnFee
  }) * 12;
  const yearlyResult = competitorAvgAnnualFees - godaddyAnnualFees;
  return Number((yearlyResult * years).toFixed(2));
};
exports.getSavings = getSavings;
const getFormattedSaving = saving => new _intlFormatter.Currency().formatDecimal(Math.floor(saving), 'en-US', 'USD', {
  excludeDecimal: true
});
exports.getFormattedSaving = getFormattedSaving;
const getMonthlySavings = (totalSavings = 0, years = 1) => getFormattedSaving(totalSavings / (12 * years));
exports.getMonthlySavings = getMonthlySavings;